import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import moment_tz from "moment-timezone";
import moment from "moment-timezone";
import { store } from 'state-management/store'
import { useDispatch } from 'react-redux'
import { changeCompetition } from 'state-management/actions'
import { useAbsoluteRoot } from 'helpers/urlRoot';
import 'moment/locale/fr'
import 'moment/locale/zh-cn'
import 'moment/locale/de'
import 'moment/locale/it'
import 'moment/locale/ja'
import 'moment/locale/ko'
import 'moment/locale/pt'
import 'moment/locale/ru'
import 'moment/locale/es'


import { useUrlFriendlyToParameters } from "./urlFriendly";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeHigh, faVolumeOff } from "@fortawesome/free-solid-svg-icons";
import { useGetConfigSports, useGetNocs, useGetOCSDataURLs, useGetScheduleStartList } from "./commonCodes";
import { RESULT_STATUS, SCHEDULE_STATUS, getResultStatusAsInteger, getScheduleStatusAsInteger, isFinishedStatus, isLessLiveStatus, isLiveStatus, isStartListStatus, scheduleIsHigherFinished, scheduleIsHigherRunning, scheduleIsRunningStatus } from "./status";
import { getLongEventRSC } from "./rsc";
import { QueryObserver, useQueryClient } from "@tanstack/react-query";

export const ALL_URL = {
  "ALL_DISC": "all-disc",
  "ALL_EVENT": "all-event",
  "ALL_DAYS": "all-days",
  "ALL_MEDAL": "all-medal",
  "ALL_NOC": "all-noc",
  "ALL_PDFs": "all-reports",
  "ALL_RECORD": "all-record",
  "ALL_GENDER": "TOT"
};

export const TYPE_DATA = {
  "NUMBER": 1,
  "DATE": 2,
  "STRING": 3,
  "RIBBON": 4,
};

export const PROCESSING_TYPE = {
  "PERSON": "person",
  "TEAM": "team"
}

export const SELECTOR_DISPLAY_TYPE = {
  "MENU": 'menu',
  "COMBO": 'combo'
}

export const SCREEN_TYPE = {
  "SCHEDULE": 'schedule',
  "BRACKETS": 'brackets',
  "RIBBON": 'ribbon'
}

export const DIR_MEDIA_TYPE = {
  "AUDIO": 'audio',
  "MEDIUM": 'medium',
  "THUMBS": 'thumbs',
  "HORSE": 'HORSE'
}

const REFRESH_JSON_TYPE = {
  "NOSTART": 1,
  "LIVE": 2,
  "FINISH": 3,
  "SPECIAL": 4,
};


export function useGetRefreshMainValues() {
  const { mirs_competition, mirs_discipline } = useUrlFriendlyToParameters()
  const dataConfigSport = useGetConfigSports({ mirs_competition, mirs_discipline });
  const configRefreshTime = dataConfigSport?.refreshTime
  const forceRefresh = configRefreshTime?.forceRefresh
  const stopRefresh = configRefreshTime?.stopRefresh
  return (
    {
      forceRefresh: forceRefresh,
      stopRefresh: stopRefresh
    }

  )
}


export function useGetRefreshTimeArray(typeRefresh = "results", rsc) {
  const { mirs_competition, mirs_rsc, mirs_discipline, mirs_language } = useUrlFriendlyToParameters()
  const internalRsc = rsc || mirs_rsc;
  const [value, setValue] = useState(0)
  //const [itemSchedule, setItemSchedule] = useState()
  const scheduleSL = useGetScheduleStartList()
  const scheduleItems = scheduleSL?.filter(schedule => schedule?.code.startsWith(internalRsc))
  const dataConfigSport = useGetConfigSports({ mirs_competition, mirs_discipline });
  const configRefreshTime = dataConfigSport?.refreshTime
  const defaultRefresh = configRefreshTime?.types.find((item) => item.code === typeRefresh)?.time
  const forceRefresh = configRefreshTime?.forceRefresh
  const stopRefresh = configRefreshTime?.stopRefresh
  const getInterval = (forceRefresh || stopRefresh) ? false : true
  const queryClient = useQueryClient();
  function setInterval(schItems) {
    let arrIntervals = [];
    let interval;
    Array.isArray(schItems) && schItems.forEach(item => {
      interval = getIntervalJSON(item, defaultRefresh)
      arrIntervals.push({ rsc: item?.code, interval: interval, schStatus: item?.status?.code })
    }
    )
    setValue(arrIntervals)
  }

  //Subscripcion a SCHSchedule
  useEffect(() => {
    if (scheduleSL) { //Check if exist query in memory 
      const observer = new QueryObserver(queryClient, {
        queryKey: ['getScheduleStartList', mirs_competition, mirs_discipline, mirs_language?.toUpperCase()],
        refetchInterval: 0,
      })
      const unsubscribe = observer.subscribe((result) => {
        //Get new values from query 
        const it = result.data?.filter(schedule => schedule?.code.startsWith(internalRsc))
        setInterval(it);
      });

      // Clean up the subscription when the component unmounts
      return () => {
        unsubscribe()
      }
    }
  }, []);




  useEffect(() => {
    if (stopRefresh) {
      setValue(0)
    } else if (forceRefresh) {
      setValue(defaultRefresh ? defaultRefresh : 5000)
    }
    //Get values first time 
    if (getInterval) {
      setInterval(scheduleItems)
    }
  }, []);
  return (value)
}


export function useGetRefreshTime(typeRefresh = "results", rsc) {
  const { mirs_competition, mirs_rsc, mirs_discipline, mirs_language } = useUrlFriendlyToParameters()
  const internalRsc = rsc || mirs_rsc;
  const [value, setValue] = useState(0)
  const [itemSchedule, setItemSchedule] = useState()
  const scheduleSL = useGetScheduleStartList()
  const scheduleItem = scheduleSL?.find(schedule => schedule?.code === internalRsc)
  const dataConfigSport = useGetConfigSports({ mirs_competition, mirs_discipline });
  const configRefreshTime = dataConfigSport?.refreshTime
  const defaultRefresh = configRefreshTime?.types.find((item) => item.code === typeRefresh)?.time
  const forceRefresh = configRefreshTime?.forceRefresh
  const stopRefresh = configRefreshTime?.stopRefresh
  const getInterval = (forceRefresh || stopRefresh) ? false : true

  const queryClient = useQueryClient();
  useEffect(() => {
    const timer = setInterval(() => {
      getNewValues();
    }, getInterval ? 60000 : 0);

    // Clean up the subscription when the component unmounts
    return () => {
      clearInterval(timer);
    }
  }, [itemSchedule]);

  //Subscripcion a SCHSchedule
  useEffect(() => {
    if (scheduleSL) { //Check if exist query in memory 
      const observer = new QueryObserver(queryClient, {
        queryKey: ['getScheduleStartList', mirs_competition, mirs_discipline, mirs_language?.toUpperCase()],
        refetchInterval: 0,
      })
      const unsubscribe = observer.subscribe((result) => {
        const it = result.data?.find(schedule => schedule?.code === internalRsc)
        setItemSchedule(it)
        setValue(getIntervalJSON(it, defaultRefresh))
        return result.data
      });

      // Clean up the subscription when the component unmounts
      return () => {
        unsubscribe()
      }
    }
  }, []);


  function getNewValues() {
    const newInterval = getIntervalJSON(itemSchedule, defaultRefresh)
    if (value !== newInterval) {
      setValue(getIntervalJSON(itemSchedule, defaultRefresh))
    }
  }

  useEffect(() => {

    if (stopRefresh) {
      setValue(0)
    } else if (forceRefresh) {
      setValue(defaultRefresh ? defaultRefresh : 5000)
    }
    //toma los valore la primera vez 
    if (getInterval) {
      setItemSchedule(scheduleItem)
      setValue(getIntervalJSON(scheduleItem, defaultRefresh))
    }
  }, []);

  return (value)
}

function getIntervalJSON(scheduleItem, defaultRefresh = 5000) {
  const sLocalStorage = localStorage.getItem("MirsDate")
  const storageLocalTime = moment(sLocalStorage).local().format(); //Local Format date from Session Variable
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; //Timezone Client
  const currentTime = moment().tz(timezone).format(); //Time Local from machine
  const localTime = moment(currentTime).local()
  const startTime = moment(scheduleItem?.startDate).local()//.format('YYYY-MM-DD HH:mm:ss')   
  const endTime = moment(scheduleItem?.endDate).local()//.format('YYYY-MM-DD HH:mm:ss')   
  const scheduleStatus = scheduleItem?.status?.code
  const resultStatus = scheduleItem?.result?.status?.code

  // si no existe endTime, toma la hora actual del sistema
  //Comprobar que exista
  let timeFinished = -1
  if (scheduleItem?.endDate) {
    const timePassEnd = moment.duration(localTime.diff(endTime));
    timeFinished = timePassEnd?.asMinutes();
  }
  /*
    console.log("currentTime", currentTime)
    console.log("localTime", localTime)
    console.log("endTime", endTime)
    console.log("timeFinished", timeFinished)
  */

  const toStart = moment.duration(startTime.diff(localTime));
  const timeToStart = toStart?.asMinutes();

  let typeRefreshJSON

  //No Iniciado 
  if (!scheduleIsHigherRunning(scheduleStatus)
    || isLessLiveStatus(resultStatus)) {
    typeRefreshJSON = REFRESH_JSON_TYPE.NOSTART
  }

  let resultStatusInteger = isNaN(resultStatus) ? getResultStatusAsInteger(resultStatus) : resultStatus;
  //Iniciado 
  if (scheduleIsRunningStatus(scheduleStatus)
    || isLiveStatus(resultStatus)
    || resultStatusInteger === RESULT_STATUS.UNOFFICIAL

  ) {
    typeRefreshJSON = REFRESH_JSON_TYPE.LIVE
  }

  //Oficial   
  if (getScheduleStatusAsInteger(scheduleStatus) === SCHEDULE_STATUS.FINISHED
    && resultStatusInteger === RESULT_STATUS.OFFICIAL) {
    typeRefreshJSON = REFRESH_JSON_TYPE.FINISH
  }

  //Casos especiales 
  if (scheduleIsHigherFinished(scheduleStatus)
    || getResultStatusAsInteger(resultStatus) === RESULT_STATUS.INTERMEDIATE) {
    typeRefreshJSON = REFRESH_JSON_TYPE.SPECIAL
  }





  //comprobar mayor de start list estado esta en marcha 
  // oficial acabo el partido y no hace falta actualizar 

  let refreshInterval = 0 //no refresca por defecto 

  if (timeToStart > 10) { //hasta 10 minutos antes de empezar
    refreshInterval = 300 * 1000 //Cada 5 min
  }
  if (timeToStart <= 10) { //antes 10 minutos antes 2horas terminado no live
    refreshInterval = defaultRefresh;
  }

  /*
      if ((typeRefreshJSON === REFRESH_JSON_TYPE.FINISH) && timeFinished > 120) { //Mas de dos horas despues de terminado
        refreshInterval = 0 //No refresca
      }
    */

  if ((typeRefreshJSON === REFRESH_JSON_TYPE.NOSTART || typeRefreshJSON === REFRESH_JSON_TYPE.SPECIAL)) { // terminado
    refreshInterval = 0 //No refresca
  }

  if ((typeRefreshJSON === REFRESH_JSON_TYPE.FINISH)) { // terminado
    refreshInterval = 0 //No refresca
  }
  if ((typeRefreshJSON === REFRESH_JSON_TYPE.FINISH) && timeFinished <= 10) { //Hasta 10 min  
    refreshInterval = 10 * 1000 //Cada 10 seg
  }


  if (typeRefreshJSON === REFRESH_JSON_TYPE.LIVE) {
    refreshInterval = defaultRefresh;
  }

  return (refreshInterval)
}

export function useScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
}

export function getDateTimeFormatNew(key) {

  const languageDateMap = {
    en: {
      BracketDateFormat: "D MMM",
      BracketDateTimeFormat: "D MMM, HH:mm",
      LongDateFormat: "dddd, MMMM Do YYYY",
      JavascriptDateFormat: "ddd, D MMM",
      LinkDateFormat2: "YYYY-MM-DD",
      dayMonthShort: "DD MMM H:mm",
      birthDate: "DD MMM YYYY"
    },
    fr: {
      BracketDateFormat: "DD MMMM",
      BracketDateTimeFormat: "D MMM, HH:mm",
      dayMonthShort: "DD MMM H:mm",
      birthDate: "DD-MMM-YY"
    },
    de: { dayMonthShort: "DD.MMM. H:mm", birthDate: "DD-MMM-YY" },
    it: { dayMonthShort: "DD MMM H:mm", birthDate: "DD/MM/YYYY" },
    pt: { dayMonthShort: "DD MMM H:mm", birthDate: "DD-MMM-YY" },
    es: { dayMonthShort: "DD MMM H:mm", birthDate: "DD-MMM-YY" },
    ja: { dayMonthShort: "MM月DD日 H:mm", birthDate: "YYYY年MM月DD日" },
    zh: { dayMonthShort: "MM月DD日 H:mm", birthDate: "DD/MM/YY" },
    ko: { dayMonthShort: "MM월 DD일 H:mm", birthDate: "YY년 MM월 DD일" },
    ru: { dayMonthShort: "DD MMM H:mm", birthDate: "DD MMM YYYY" },
  }
  let lng = store.getState().appGlobal.locale.toLowerCase() || 'en';
  return languageDateMap[lng][key];

}

export function getDateTimeFormat(format) {
  //const { mirs_language } = useUrlFriendlyToParameters();
  let lng = moment.locale()
  switch (lng) {
    case 'en':
      return engDateTimeFormat(format)
    case 'fr':
      return fraDateTimeFormat(format)
    case 'de':
      return deuDateTimeFormat(format)
    case 'it':
      return itaDateTimeFormat(format)
    case 'pt':
      return porDateTimeFormat(format)
    case 'es':
      return spaDateTimeFormat(format)
    case 'ja':
      return jpnDateTimeFormat(format)
    case 'zh-cn':
      return zhDateTimeFormat(format)
    case 'ko':
      return korDateTimeFormat(format)
    case 'ru':
      return rusDateTimeFormat(format)
    default:
      return engDateTimeFormat(format)
  }
}

export function engDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "D dddd"
    },
    {
      type: "MonthShort", //NEW
      format: "MMM"
    },
    {
      type: "DateTimeLong",   //Done Replace //LongDateFormat
      format: "dddd D MMMM YYYY H:mm"
    },
    {
      type: "DateLong",
      format: "dddd D MMMM YYYY"
    },

    {
      type: "DayMonthShort",  //no changes
      format: "D MMM"
    },
    {
      type: "DayMonthShortHourMinute", //Done Replace // DayMonthShortHourMinute
      format: "D MMM H:mm"
    },
    {
      type: "DayName-DayNum-MonthShort",//DONE Replace  //DayName-DayNum-MonthShort
      format: "ddd, D MMM"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },

    {
      type: "DayMonthShortYear",
      format: "D MMM YYYY"
    },
    {
      type: "OrdinalDateTimeLong",
      format: "dddd Do MMMM YYYY - H: mm"
    },


  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function fraDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "dddd D"
    },
    {
      type: "MonthShort", //NEW
      format: "MMM"
    },
    {
      type: "DateTimeLong",   //PageVenueDate
      format: "dddd D MMMM YYYY HH\\h mm"
    },
    {
      type: "DateLong",
      format: "dddd D MMMM YYYY"
    },

    {
      type: "DayMonthShort",
      format: "D MMM"
    },
    {
      type: "DayMonthShortHourMinute",
      format: "D MMM HH\\h mm"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "ddd, D MMM"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },

    {
      type: "DayMonthShortYear",
      format: "DD MMM YYYY"
    },
    {
      type: "OrdinalDateTimeLong",
      format: "dddd Do MMMM YYYY HH\\h mm"
    },


  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function deuDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "dddd, D."
    },
    {
      type: "MonthShort", //NEW
      format: "MMM."
    },
    {
      type: "DateTimeLong",   //PageVenueDate
      format: "dddd, D. MMMM YYYY H:mm U\\hr"
    },
    {
      type: "DateLong",
      format: "dddd, D. MMMM YYYY"
    },
    {
      type: "DayMonthShort",
      format: "D. MMM"
    },
    {
      type: "DayMonthShortHourMinute",
      format: "D. MMM H:mm U\\hr"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "ddd, D. MMM."
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },

    {
      type: "DayMonthShortYear",
      format: "DD-MMM-YY"
    },
    {
      type: "OrdinalDateTimeLong",
      format: "dddd, Do MMMM YYYY H:mm U\\hr"
    },

  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function itaDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "dddd D"
    },
    {
      type: "MonthShort", //NEW
      format: "MMM"
    },
    {
      type: "DateTimeLong",   //PageVenueDate
      format: "dddd D MMMM YYYY H:mm"
    },
    {
      type: "DateLong",
      format: "dddd D MMMM YYYY"
    },

    {
      type: "DayMonthShort",
      format: "D MMM"
    },
    {
      type: "DayMonthShortHourMinute",
      format: "D MMM H:mm"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "ddd D MMM"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },
    {
      type: "DayMonthShortYear",
      format: "D MMM YYYY"
    },
    {
      type: "OrdinalDateTimeLong",
      format: "dddd Do MMMM YYYY H:mm"
    },


  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function porDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "D dddd"
    },
    {
      type: "MonthShort", //NEW
      format: "MMM"
    },
    {
      type: "DateTimeLong",   //PageVenueDate
      format: "dddd, D \\d\\e MMMM \\d\\e YYYY H:mm"
    },
    {
      type: "DateLong",
      format: "dddd, D \\d\\e MMMM \\d\\e YYYY"
    },

    {
      type: "DayMonthShort",
      format: "D MMM"
    },
    {
      type: "DayMonthShortHourMinute",
      format: "D MMM H:mm"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "ddd, D MMM"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },
    {
      type: "DayMonthShortYear",
      format: "D MMM YYYY"
    },
    {
      type: "OrdinalDateTimeLong",
      format: "dddd, Do \\d\\e MMMM \\d\\e YYYY H:mm"
    },

  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function spaDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "dddd D"
    },
    {
      type: "MonthShort", //NEW
      format: "MMM"
    },
    {
      type: "DateTimeLong",   //PageVenueDate
      format: "dddd, D \\d\\e MMMM \\d\\e YYYY H:mm"
    },
    {
      type: "DateLong",
      format: "dddd, D \\d\\e MMMM \\d\\e YYYY"
    },
    {
      type: "DayMonthShort",
      format: "D MMM"
    },
    {
      type: "DayMonthShortHourMinute",
      format: "D MMM H:mm"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "ddd D MMM"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },

    {
      type: "DayMonthShortYear",
      format: "D MMM YYYY"
    },
    {
      type: "OrdinalDateTimeLong",
      format: "dddd, Do \\d\\e MMMM \\d\\e YYYY H:mm"
    },

  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function jpnDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "D日 dddd"
    },
    {
      type: "MonthShort", //NEW
      format: "MMM"
    },
    {
      type: "DateTimeLong",   //PageVenueDate
      format: "YYYY年M月D日 dddd H:mm"
    },
    {
      type: "DateLong",
      format: "YYYY年M月D日 dddd"
    },
    {
      type: "DayMonthShort",
      format: "MMMD日" // "MM月DD日 H:mm"
    },
    {
      type: "DayMonthShortHourMinute",
      format: "MMMD日 H:mm"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "MMMD日 (ddd)"//"M月D日（ddd）"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },

    {
      type: "DayMonthShortYear",
      format: "YYYY年M月D日"
    },
    {
      type: "OrdinalDateTimeLong",
      format: "YYYY年M月Do日 dddd H:mm"
    },

  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function zhDateTimeFormat(format) {
  const obj = [


    {
      type: "DayNum-DayName",//New
      format: "D日, dddd"
    },
    {
      type: "MonthShort", //NEW
      format: "MMM"
    },
    {
      type: "DateTimeLong",   //PageVenueDate
      format: "YYYY年M月D日, dddd, H:mm"
    },
    {
      type: "DateLong",
      format: "YYYY年M月D日 dddd"
    },
    {
      type: "DayMonthShort",
      format: "MMMD日" //MM月DD日
    },
    {
      type: "DayMonthShortHourMinute",
      format: "MMMD日 H:mm"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "MMMD日, ddd"//"M月D日，ddd"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },

    {
      type: "DayMonthShortYear",
      format: "YYYY年M月D日"
    },
    {
      type: "OrdinalDateTimeLong",
      format: "YYYY年M月Do日, ddd, H:mm"
    },
  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function korDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "D일 dddd"
    },
    {
      type: "MonthShort", //NEW
      format: "MMM"
    },
    {
      type: "DateTimeLong",   //PageVenueDate
      format: "YYYY년M월D일 dddd H:mm"
    },
    {
      type: "DateLong",
      format: "YYYY년M월D일 dddd"
    },

    {
      type: "DayMonthShort",
      format: "MMM D일" //"MM월 DD일 
    },
    {
      type: "DayMonthShortHourMinute",
      format: "MMM DD일 H시 mm분"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "MMM DD일 ddd" //"M월 D일 (ddd)"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },

    {
      type: "DayMonthShortYear",
      format: "YY년 M월 D일"
    },

    {
      type: "OrdinalDateTimeLong",
      format: "YYYY년M월Do일 dddd H:mm"
    },


  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}
export function rusDateTimeFormat(format) {
  const obj = [
    {
      type: "DayNum-DayName",//New
      format: "dddd D"
    },
    {
      type: "MonthShort",
      format: "MMM"
    },
    {
      type: "DateTimeLong",
      format: "D dddd YYYY MMM H:mm"
    },
    {
      type: "DateLong",
      format: "D dddd YYYY MMM"
    },
    {
      type: "DayMonthShort",
      format: "D MMM"
    },
    {
      type: "DayMonthShortHourMinute",
      format: "D MMM, H:mm"
    },
    {
      type: "DayName-DayNum-MonthShort",
      format: "ddd, DD MMM"
    },
    {
      type: "HourMinute",
      format: "H:mm"
    },
    {
      type: "LinkDateFormat2", //Reports
      format: "YYYY-MM-DD"
    },
    {
      type: "DayMonthShortYear",
      format: "D MMM YYYY"
    },

    {
      type: "OrdinalDateTimeLong",
      format: "Do dddd YYYY MMM H:mm"
    },


  ]

  const resp = obj.find(item => item.type === format)
  return (resp?.format)
}

export function setLocaleLng() {
  let lng = store.getState().appGlobal.locale.toLowerCase()
  if (lng === 'zh') {
    lng = 'zh-cn'
  }
  if (lng === 'hi') {
    lng = 'en'
  }
  moment.locale(lng)
}

export function dateFormat(_date, _timeZone, _format) {
  _timeZone = (_timeZone === "" || _timeZone === undefined) ? store.getState().appGlobal.timezone : _timeZone;
  _format = (_format === "" || _format === undefined) ? "YYYY-MM-DD" : _format;
  return moment_tz
    .utc(new Date(_date))
    .tz(_timeZone)
    .format(_format);
}
export function dateFormatNoTz(_date, _format) {
  _format = (_format === "" || _format === undefined) ? "YYYY-MM-DD" : _format;
  return moment(_date).format(_format);
}

export function dateToday(_timeZone, _format) {
  return dateFormat(Date.now(), _timeZone, _format)
}

export function groupByDate(array, key, _timeZone) {
  _timeZone = (_timeZone === "" || _timeZone === undefined) ? store.getState().appGlobal.timezone : _timeZone;
  const res = array.reduce((a, c) => (a[dateFormat(c[key], _timeZone)] = (a[dateFormat(c[key], _timeZone)] || []).concat(c), a), {})
  return res;
}


export function groupByDateNoTz(array, key) {
  const res = array.reduce((a, c) => (a[moment(c[key]).format("YYYY-MM-DD")] = (a[moment(c[key]).format("YYYY-MM-DD")] || []).concat(c), a), {})
  return res;
}


export function isValidDate(date) {
  return moment(date, "YYYY-MM-DD", true).isValid();
}

export function isValidDateTime(date) {
  return moment(date, "YYYY-MM-DD HH:mm", true).isValid();
}


export function CompetitionToStore(competition) {
  //Store championship in Store
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(changeCompetition(competition));
  }, [competition, dispatch])
}

export function CompetitionFromStore() {
  return store.getState().appGlobal.competition
}

export function RscFromStore() {
  return store.getState().appGlobal.rsc
}

export function getKeyByValue(object, keyName, value) {
  return Object.keys(object).find(key => object[keyName] === value);
}

/**
 * Process filtered data and calculate gender counts by discipline based on data type.
 *
 * @param {Array} filterData - The filtered data to process.
 * @param {string} dataType - The type of data ('person' or 'team').
 * @returns {Array} An array of processed data with gender counts by discipline.
 */
export function processFilteredData(filterData, mirs_discipline, dataType) {
  // Initialize an empty array to store the processed data.
  const results = [];

  // Create an object to store discipline counts.
  const dataCounts = {};

  // Iterate through the filtered data to calculate gender counts.
  filterData?.forEach(dataItem => {
    let gender;
    let discipline;
    let personDisciplines;

    // Determine the discipline based on the dataType and mirs_discipline conditions
    if (dataType === PROCESSING_TYPE.PERSON) {
      if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
        personDisciplines = dataItem?.disciplines?.filter(dis => dis?.code === mirs_discipline);
      } else {
        personDisciplines = dataItem?.disciplines;
      }
    } else {
      discipline = dataItem?.discipline;
    }

    const disciplineCode = discipline?.code;

    // Check the data type to access gender information correctly.
    if (dataType === PROCESSING_TYPE.PERSON) {
      gender = dataItem?.personGender?.code;
      // If gender information is available, update counts based on data type.
      if (gender) {
        personDisciplines.forEach(discipline => {
          // Initialize discipline counts if not already present.
          if (!dataCounts[discipline?.code]) {
            dataCounts[discipline?.code] = {
              M: 0,
              F: 0,
              T: 0,
            };
          }
          // Update gender-specific and total counts.
          dataCounts[discipline?.code][gender]++;
          dataCounts[discipline?.code].T++;
        });
      }
    } else if (dataType === PROCESSING_TYPE.TEAM) {
      // Handle accessing athlete data within a team
      if (dataItem?.athletes) {
        dataItem?.athletes.forEach(athlete => {
          gender = athlete?.person?.personGender?.code;
          if (gender) {
            // Initialize discipline counts if not already present.
            if (!dataCounts[disciplineCode]) {
              dataCounts[disciplineCode] = {
                M: 0,
                F: 0,
                T: 0,
              };
            }
            // Update gender-specific and total counts.
            dataCounts[disciplineCode][gender]++;
            dataCounts[disciplineCode].T++;
          }
        });
      }
    }
  });

  // Convert dataCounts to the desired format and build the results array.
  for (const disciplineCode in dataCounts) {
    let disciplineObj;

    if (dataType === PROCESSING_TYPE.PERSON) {
      disciplineObj = filterData.find(dataItem => dataItem?.disciplines?.some(disc => disc?.code === disciplineCode))?.disciplines?.find(disc => disc?.code === disciplineCode);
    } else {
      disciplineObj = filterData.find(dataItem => dataItem?.discipline?.code === disciplineCode)?.discipline;
    }

    if (disciplineCode !== undefined && disciplineObj !== undefined) {
      results.push({
        discipline: disciplineObj,
        gender: dataCounts[disciplineCode]
      });
    }
  }

  // Return the processed data.
  return results;
}

export const getAge = (dateString) => {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export const getHeight = (heightInCms) => {
  const realFeet = ((heightInCms * 0.393700) / 12);
  let feet = Math.floor(realFeet);
  let inches = Math.round((realFeet - feet) * 12);
  if (inches === 12) {
    feet += 1;
    inches = 0;
  }
  const meters = (heightInCms / 100).toFixed(2);
  // return `${meters}/${feet}'${inches}''`;
  return ((feet || inches) && meters) ? `${meters}/${feet}'${inches}''` : '';
}

export const getWeight = (weightInKg) => {
  const weightInLb = Math.round((weightInKg * 2.2046226218));
  return `${weightInKg}/${weightInLb}`;
}

export const getEntityLessThanTen = (array, discipline, eventString) => {

  const filteredOrders = array?.filter(order => {
    return order?.order < 10;
  });
  return filteredOrders;
};

export const getEntityMoreThanOrEqualTen = (array, discipline, eventString) => {

  const filteredOrders = array?.filter(order => {
    return order?.order >= 10;
  });
  return filteredOrders;
};

// ignores case-sensitive
const getValueUppercase = value => (typeof value === 'string' ? value.toUpperCase() : value);

/**
 * Filters an array of objects (one level-depth) with multiple criteria.
 *
 * @param  {Array}  array: the array to filter
 * @param  {Object} filters: an object with the filter criteria
 * @return {Array}
 */
export function findArray(array, filters, sensitive = false) {
  if (array === undefined) {
    return ''
  }

  if (array && Array.isArray(array)) {
    const filterKeys = Object.keys(filters);
    const element = array.find(item => {
      // validates all filter criteria
      return filterKeys.every(key => {
        // ignores an empty filter
        if (!filters[key].length) return true;
        if (sensitive) {
          return filters[key].find(filter => filter === item[key]);

        } else {
          return filters[key].find(filter => getValueUppercase(filter) === getValueUppercase(item[key]));
        }
      });
    });
    return typeof element === "object" ? element : '';
  } else {
    return ''
  }
}

export function findParticResult(array, code) {
  if (!code) return '';
  return array?.find(item => item?.participant ? item?.participant?.code === code : '');
}

/**
 * Filters an array of objects (one level-depth) with multiple criteria.
 *
 * @param  {Array}  array: the array to filter
 * @param  {Object} filters: an object with the filter criteria
 * @return {Array}
 */
export function filterArray(array, filters) {
  if (array === undefined) {
    return ''
  }
  const filterKeys = Object.keys(filters);
  const element = array.filter(item => {
    // validates all filter criteria
    return filterKeys.every(key => {
      // ignores an empty filter
      if (!filters[key].length) return true;
      return filters[key].find(filter => getValueUppercase(filter) === getValueUppercase(item[key]));
    });
  });
  return typeof element === "object" ? element : '';

}

export function findObject(arr, item, val) {
  const element = arr.find((value) => {
    return value[item] === val;
  });
  return typeof element === "object" ? element : '';
}

export function findObject2(arr, item, val, item2, val2) {
  const element = arr.find((value) => {
    return value[item] === val && value[item2] === val2;
  });
  return typeof element === "object" ? element : '';
}

export function arraysEqual(a1, a2) {
  /* WARNING: arrays must not contain {objects} or behavior may be undefined */
  return JSON.stringify(a1) === JSON.stringify(a2);
}

export function capitalizeFirstLetter(string) {
  return string === undefined ? '' : string.charAt(0).toUpperCase() + string.slice(1)
}

export function capitalize(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
}

export function isParalympic(_competition) {
  return (_competition === "PG2024");
}

export function isInvictus(_competition) {
  return (_competition === "IG2023");
}


export function isRTVE(_competition) {
  return (true)
  //const host = window.location.hostname
  //return process.env.REACT_APP_RTVE_HOST_NAMES?.includes(host);
}

export function isSwitchHost() {
  if (isServerSide()) return true;
  const host = window.location.hostname
  return process.env.REACT_APP_SWITCH_HOST_NAMES?.includes(host);
}

export function isCustomEvents() {
  if (isServerSide()) return false;
  const host = window.location.hostname
  return process.env.REACT_APP_CUSTOM_EVENTS?.includes(host);
}

export function isHideHeaderDefault() {
  if (isServerSide()) return true;
  const host = window.location.hostname
  return process.env.REACT_APP_HIDE_HEADER_DEFAULT?.includes(host);
}

export const sortDataByField = (arrayOriginal, field, asc = true, type = TYPE_DATA.NUMBER, clone = false) => {
  if (!Array.isArray(arrayOriginal)) { return arrayOriginal }
  let array = clone ? [...arrayOriginal] : arrayOriginal
  if (Array.isArray(array)) {
    if (type === TYPE_DATA.DATE) {
      if (asc) {
        array.sort((a, b) => (new Date(a[field]) > new Date(b[field])) ? 1 : -1);
      } else {
        array.sort((a, b) => (new Date(b[field]) > new Date(a[field])) ? 1 : -1);
      }
    } else if (type === TYPE_DATA.NUMBER) {
      if (asc) {
        array.sort((a, b) => {
          if (field in a && field in b) {
            return Number(a[field]) - Number(b[field])
          };
          if (field in a) {
            return -1;
          };
          if (field in b) {
            return 1;
          };
          return 0;
        });
      } else {
        array.sort((a, b) => {
          if (field in a && field in b) {
            return Number(b[field]) - Number(a[field])
          };
          if (field in a) {
            return -1;
          };
          if (field in b) {
            return 1;
          };
          return 0;
        });
      }
    } else if (type === TYPE_DATA.RIBBON) {
      if (asc) {
        array.sort((a, b) => Number(a[field]) > Number(b[field]) ? 1 : Number(a[field]) < Number(b[field]) ? -1 : a?.code?.localeCompare(b?.code))
      } else {
        array.sort((a, b) => Number(b[field]) > Number(a[field]) ? 1 : Number(b[field]) < Number(a[field]) ? -1 : a?.code?.localeCompare(b?.code))
      }
    } else {
      if (asc) {
        //array.sort((a, b) => (a[field] > b[field]) ? 1 : -1)
        array.sort((a, b) => a[field].localeCompare(b[field]))
      } else {
        array.sort((a, b) => b[field].localeCompare(a[field]))
        //array.sort((a, b) => (b[field] > a[field]) ? 1 : -1)
      }
    }
  }
  return array
};


export function getFullPath(code, mediaDir, mediaType) {
  const competition = CompetitionFromStore();
  let longId = code?.padStart(9, '0');
  let fullPath = `${process.env.REACT_APP_SERVER_URL_RESOURCES}/pic/${competition}/`;
  fullPath += (mediaDir === DIR_MEDIA_TYPE.HORSE) ? `${mediaDir}/${code}${mediaType}`
    : `${longId?.substring(0, 3)}/${longId?.substring(3, 6)}/${mediaDir}/${code}${mediaType}`;
  return fullPath;
}

export function usePathFlag(code) {
  const competition = CompetitionFromStore();
  const { urlRoot } = useAbsoluteRoot();

  let path;
  if (isParalympic(competition)) {
    path = `${urlRoot}assets/images/flags/PG2024/${code}.webp`;
  } else {
    path = `${urlRoot}assets/images/flags/OG2024/${code}.webp`;
  }

  return (path);
}

export function usePathPhoto(code) {
  const { urlRoot } = useAbsoluteRoot();

  return (`${urlRoot}assets/images/photos/photo.webp`);
};

export function usePathPhotoOrDefault(code, image) {
  const { urlRoot } = useAbsoluteRoot();
  const imgExtension = image?.imageExtension
  const fullPath = getFullPath(code, DIR_MEDIA_TYPE.MEDIUM, imgExtension)
  let placeholderUrl = `${urlRoot}assets/images/photos/photo.webp`;

  return {
    mainURL: imgExtension ? fullPath : placeholderUrl,
    placeholderURL: placeholderUrl,
  };
};

// Function to create clickable link
export function createClickableLink(htmlString) {
  const linkRegex = /(http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?(?=<)/;
  let htmlStringWithlink = htmlString.replace(linkRegex, (match) => `<a href="${match}" target="blank">${match}</a>`);
  return htmlStringWithlink;
}

export const SoundPlayer = ({ audioPath }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [error, setError] = useState(null);
  const audioPlayerRef = useRef(null);
  const [showSoundIcon, setShowSoundIcon] = useState(true);

  const toggleSound = () => {
    if (isPlaying) {
      audioPlayerRef.current.pause();
      audioPlayerRef.current.currentTime = 0; // Reset playback position to the beginning
    } else {
      audioPlayerRef.current.play().catch((err) => {
        setError(err.message); // Handle play error
      });
    }
    setIsPlaying(!isPlaying);
  };

  const handleEnded = () => {
    setIsPlaying(false);
    // Additional logic after audio playback finishes
  };

  const handleError = (error) => {
    setError(error.message);
    setShowSoundIcon(false);
    // Additional error handling logic
  };

  return (
    <span className="sound-player">
      {showSoundIcon && <>
        <span className="speaker-icon" onClick={toggleSound}>
          {isPlaying ? <FontAwesomeIcon fade icon={faVolumeHigh} size="lg" /> : <FontAwesomeIcon icon={faVolumeOff} size="lg" />}
        </span>
        <audio
          ref={audioPlayerRef}
          src={audioPath}
          onEnded={handleEnded}
          onError={(e) => handleError(e.target.error)}
        />
      </>
      }
    </span>
  );
};

export function isNumeric(str) {
  return !isNaN(str)
}

// method to split nocs or disciplines array into number of columns
export function splitArrayIntoFourColumns(arr) {
  if (!arr || arr?.length === 0) return [];
  let remaining = arr.length % 4;
  const base = Math.floor(arr.length / 4);
  const firstArrayLastIndex = base + (remaining > 0 ? 1 : 0);
  if (remaining > 0) remaining--;
  const secondArrayLastIndex = firstArrayLastIndex + base + (remaining > 0 ? 1 : 0);
  if (remaining > 0) remaining--;
  const thirdArrayLastIndex = secondArrayLastIndex + base + (remaining > 0 ? 1 : 0);

  const arrayOfColumns = [
    <div key={1} className="gridColumn"> {arr.slice(0, firstArrayLastIndex)}</div>,
    <div key={2} className="gridColumn"> {arr.slice(firstArrayLastIndex, secondArrayLastIndex)}</div>,
    <div key={3} className="gridColumn"> {arr.slice(secondArrayLastIndex, thirdArrayLastIndex)}</div>,
    <div key={4} className="gridColumn"> {arr.slice(thirdArrayLastIndex)}</div>
  ];
  return arrayOfColumns;
}

export function valuerOrNull(value) {
  return value ? value : null
}

export function isServerSide() {
  return (typeof window === "undefined" || typeof document === "undefined")
}

export function isOdd(num) {
  if (num % 2 === 0) {
    return true; // es par
  }
  else {
    return false; // es impar
  }
}

export function useGetFunctionOCSUrl() {
  const dataUrls = useGetOCSDataURLs()

  return function (urlOrigin, type, paramsURL) {
    const { mirs_event, mirs_discipline, mirs_noc } = paramsURL

    if (isSwitchHost()) {
      let switchUrl;
      let eventUrl = mirs_event && dataUrls?.data?.scheduleByEvent[getLongEventRSC(mirs_event)]
      switch (type) {
        case 'schedule':
          switchUrl = (mirs_discipline)
            ? (eventUrl)
              ? eventUrl
              : dataUrls?.data?.scheduleByDiscipline[mirs_discipline]
            : urlOrigin
          break;
        case 'schedulebynoc':
          switchUrl = dataUrls?.data?.scheduleByNOC[mirs_noc]
          break;
        case 'medal':
          switchUrl = (mirs_discipline) ? dataUrls?.data?.medalsByDiscipline[mirs_discipline] : urlOrigin
          break;
        case 'medallistsbynoc':
          switchUrl = dataUrls?.data?.medalsByNOC[mirs_noc]
          break;
        default:
          switchUrl = urlOrigin
          break;
      }

      return switchUrl
    } else {
      return urlOrigin
    }
  }
}

export function GetNocMedalAndParticipant(params) {
  const noc = useGetNocs({ ...params })?.nocs?.find(n => n.code === params?.mirs_noc);
  return noc?.medal === 'Y' && noc?.note === "P";
}
